export default __webpack_public_path__ + "static/media/coinbaseIcon.ebae83a6.svg";